import * as React from "react";
import {connect} from "react-redux";
import {WithStyles, withStyles} from "@material-ui/core/styles";
import {Add} from "@material-ui/icons";
import {IFamilyMember} from "@app-types/websocket/family.types";
import {ICreateTodo, RENEWAL, TODO_TITLE_MAX_LENGTH, TODO_TITLE_MIN_LENGTH, TODO_TYPE} from "@app-types/websocket/todo.types";
import * as TodoActions from "@services/todos/todo.action";
import {FamilyMemberType} from "@services/family/family.constants";
import TranslateNew from "@translate/TranslateNew";
import {NewPackingListItemRowStyle as styles} from "./NewPackingListItemRow.style";

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof styles> {
  scheduleId: number;
  // The child new items are tagged with, and the name of their part of the list.
  tagged?: number;
  groupName?: string;
  family: IFamilyMember[];
  createTodo: (data: ICreateTodo) => void;
}

// Inline replacement for the old add-button + dialog; uses the dialog's defaults for a new packing item.
export const buildPackingListItem = (title: string, scheduleId: number, family: IFamilyMember[],
                                     tagged?: number): ICreateTodo => ({
  title,
  description: "",
  assigned: [],
  visible: family.filter(member => member.role === FamilyMemberType.PARENT
    || member.role === FamilyMemberType.VIEWER || member.role === FamilyMemberType.CHILD).map(member => member.id),
  renewal: RENEWAL.DROPPING_OFF,
  type: TODO_TYPE.HANDOVER,
  scheduleId,
  ...(tagged !== undefined ? {tagged} : {}),
});

const NewPackingListItemRow = (props: IProps) => {
  const {classes} = props;
  const [title, setTitle] = React.useState("");
  const [tooShort, setTooShort] = React.useState(false);

  const submit = () => {
    const trimmed = title.trim();
    if (trimmed.length === 0) {
      return;
    }
    // Keep the text so it can be finished; the server would reject it and the item would just vanish.
    if (trimmed.length < TODO_TITLE_MIN_LENGTH) {
      setTooShort(true);
      return;
    }
    props.createTodo(buildPackingListItem(trimmed, props.scheduleId, props.family, props.tagged));
    setTitle("");
  };

  return (
    <>
      <div className={classes.row}>
        <Add className={classes.addIcon} />
        <input type="text" className={classes.input} value={title} placeholder={tn.lang.addListTodo}
          aria-label={props.groupName ? `${tn.lang.addListTodo}: ${props.groupName}` : tn.lang.addListTodo}
          maxLength={TODO_TITLE_MAX_LENGTH} spellCheck={true} autoCorrect="on"
          {...{enterkeyhint: "done"}}
          onChange={event => {
            setTitle(event.target.value);
            setTooShort(false);
          }}
          onBlur={submit}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              event.preventDefault();
              submit();
            }
          }} />
      </div>
      {tooShort && (
        <div className={classes.hint} role="alert">{tn.lang.todoTitleMin(TODO_TITLE_MIN_LENGTH)}</div>
      )}
    </>
  );
};

function mapStateToProps(state: any) {
  return {family: state.family.family};
}

const mapDispatchToProps = {
  createTodo: TodoActions.createTodo,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NewPackingListItemRow));



// WEBPACK FOOTER //
// ./src/components/next-handover/NewPackingListItemRow.tsx